<div>
  <div class="main {{ mode }}" [routerLink]="['doddle', doddle.id]">
    @if (firstMediaItem) {
      @if (firstMediaItem.type === MEDIA_TYPE.image) {
        <img
          class="media"
          loading="lazy"
          [width]="firstMediaItem.width"
          [height]="firstMediaItem.height"
          [src]="firstMediaItem.thumbnailURL"
          class="media-thumbnail"
          alt=""
        />
      } @else {
        <video
          class="media-thumbnail"
          [src]="firstMediaItem.URL"
          [width]="firstMediaItem.width"
          [height]="firstMediaItem.height"
        ></video>
      }
    } @else {
      <div class="media-placeholder" *ngIf="mode === 'list'">
        <ly-icon icon="image"></ly-icon>
      </div>
    }

    <div class="content-wrapper">
      <div class="content-header">
        <ly-post-status-indicator
          class="status"
          [status]="doddle.status"
        ></ly-post-status-indicator>
        <div class="channels">
          @if (doddle.channels && doddle.channels.length <= 2) {
            @for (channel of doddle.channels; track $index) {
              <ly-channel-type-icon [channelType]="channel.platform" />
            }
          }
          @if (doddle.channels && doddle.channels.length > 2) {
            @for (channel of doddle.channels.slice(0, 2); track $index) {
              <ly-channel-type-icon [channelType]="channel.platform" />
            }
            <span class="channels-counter"
              >+{{ doddle.channels.length - 2 }}</span
            >
          }
        </div>
      </div>

      <h5 *ngIf="doddle.title" class="doddle-title">{{ doddle.title }}</h5>

      <p class="content">
        {{ doddle.content }}
      </p>
    </div>
  </div>
</div>
